import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ApplicationsPage from "./pages/ApplicationsPage";
import UsPage from "./pages/UsPage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

function App() {
  const { t } = useTranslation();
  const navigation = t('navigation');
  return (
    <Router basename="/">
      <ScrollToTop />
      <ScrollToTopButton />
      <Routes>
        <Route path={`${navigation[0].href}`} element={<HomePage />} />
        <Route path={`${navigation[1].href}`} element={<ServicesPage />} />
        <Route path={`${navigation[2].href}`} element={<ApplicationsPage />} />
        <Route path={`${navigation[3].href}`} element={<UsPage />} />
        <Route path={`${navigation[4].href}`} element={<ContactPage />} />
        <Route
          path="*"
          element={
            <main style={{ padding: "1rem", color: 'white' }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Routes>
    </Router>
  );
}

export default function WrappedApp() {
  return (
    <Suspense fallback="...is loading">
      <App />
    </Suspense>
  );
}
